import actionTypes from '../actions'

const cashflowTableDataDefault = {
  records: [],
  pageNo: 1,
  pageSize: 20,
  totalCount: 0,
  sortBy: 'cleared_on_date',
  desc: true,
  trxType: [],
}

const payablesTableDataDefault = {
  records: [],
  pageNo: 1,
  pageSize: 20,
  totalCount: 0,
  sortBy: 'issue_date',
  desc: true,
  status: [],
}

const receivablesTableDataDefault = {
  records: [],
  pageNo: 1,
  pageSize: 20,
  totalCount: 0,
  sortBy: 'issue_date',
  desc: true,
}

const unpaidInvoicesTableDataDefault = {
  records: [],
  pageNo: 1,
  pageSize: 5,
  totalCount: 0,
  sortBy: 'issue_date',
  desc: true,
}

const paidInvoicesTableDataDefault = {
  records: [],
  pageNo: 1,
  pageSize: 5,
  totalCount: 0,
  sortBy: 'issue_date',
  desc: true,
}

const unpaidBillsTableDataDefault = {
  records: [],
  pageNo: 1,
  pageSize: 5,
  totalCount: 0,
  sortBy: 'issue_date',
  desc: true,
}

const paidBillsTableDataDefault = {
  records: [],
  pageNo: 1,
  pageSize: 5,
  totalCount: 0,
  sortBy: 'issue_date',
  desc: true,
}

//TODO: Split the cashflow reducer like sales reducer
const initialState = {
  //TODO: remove the hardcoded data once the API is ready
  companyId: '9678c6e3-7cf7-4658-a216-b909dd825045',
  cashflowGraphData: [],
  payablesGraphData: [],
  receivablesGraphData: [],
  defaultBusinessId: null, //NOTE: for vault

  //Finiacial data
  loadingCashflowData: false,
  loadingCashflowChartData: false,
  loadingCashflowTableData: false,

  loadingPayblesData: false,
  loadingPayblesChartData: false,
  loadingPayblesTableData: false,

  loadingReceivablesData: false,
  loadingReceivablesChartData: false,
  loadingReceivablesTableData: false,

  loadingUnpaidInvoicesData: false,
  loadingPaidInvoicesData: false,
  loadingUnpaidBillsData: false,
  loadingPaidBillsData: false,

  cashflowChartData: [],
  payablesChartData: [],
  receivablesChartData: [],
  cashflowTableData: cashflowTableDataDefault,
  payablesTableData: payablesTableDataDefault,
  unpaidBills: unpaidBillsTableDataDefault,
  paidBills: paidBillsTableDataDefault,
  receivablesTableData: receivablesTableDataDefault,
  unpaidInvoices: unpaidInvoicesTableDataDefault,
  paidInvoices: paidInvoicesTableDataDefault,

  cashflow: [],
  payables: [],
  // eslint-disable-next-line
  unpaidBills: [],
  // eslint-disable-next-line
  paidBills: [],

  receivables: [],
  // eslint-disable-next-line
  unpaidInvoices: [],
  // eslint-disable-next-line
  paidInvoices: [],

  summaryCashflowData: {},
  payablesSummary: {},
  receivablesSummary: {},
  user: {},
  business: {},
  dashboardInfo: {
    alerts_info: [],
    brc_info: [],
    business_info: {},
    business_list: [],
    user_info: {},
    vault_info: {},
  },
  cashflowPopupData: [],
  codatIntegrated: false,

  //filter options
  cashflowTrxTypesOptions: [],
  payableBillStatusOptions: [],
  receivableInvoiceStatus: [],
  disputePaymentStatusOptions: [],
  trxPaymentMethodOptions: [],
  trxPaymentStatusOptions: [],
  trxTypeOptions: [],
}

const reducer = (state = initialState, action) => {
  if (action.type === actionTypes.SETCOMPANYID) {
    return {
      ...state,
      companyId: action.data,
    }
  }

  if (action.type === actionTypes.CASHFLOWDATAFETCHED) {
    return {
      ...state,
      cashflow: action.data,
    }
  }
  if (action.type === actionTypes.CASHFLOWCHARTDATAFETCHED) {
    return {
      ...state,
      cashflowChartData: action.data,
    }
  }
  if (action.type === actionTypes.CASHFLOWTABLEDATAFETCHED) {
    if (!action.data) {
      return state
    }
    return {
      ...state,
      cashflowTableData: { ...action.data },
    }
  }

  if (action.type === actionTypes.PAYABLESDATAFETCHED) {
    return {
      ...state,
      payables: action.data,
    }
  }
  if (action.type === actionTypes.PAYABLESCHARTDATAFETCHED) {
    return {
      ...state,
      payablesChartData: action.data,
    }
  }
  if (action.type === actionTypes.PAYABLESGRAPHDATAFETCHED) {
    return {
      ...state,
      payablesGraphData: action.data,
    }
  }
  if (action.type === actionTypes.PAYABLESTABLEDATAFETCHED) {
    return {
      ...state,
      payablesTableData: action.data,
    }
  }
  if (action.type === actionTypes.UNPAIDBILLSDATAFETCHED) {
    if (!action.data) {
      return state
    }
    return {
      ...state,
      unpaidBills: { ...action.data },
    }
  }
  if (action.type === actionTypes.PAIDBILLSDATAFETCHED) {
    if (!action.data) {
      return state
    }
    return {
      ...state,
      paidBills: { ...action.data },
    }
  }
  if (action.type === actionTypes.RECEIVABLESDATAFETCHED) {
    return {
      ...state,
      receivables: action.data,
    }
  }
  if (action.type === actionTypes.RECEIVABLESCHARTDATAFETCHED) {
    return {
      ...state,
      receivablesChartData: action.data,
    }
  }
  if (action.type === actionTypes.RECEIVABLESTABLEDATAFETCHED) {
    if (!action.data) {
      return state
    }
    return {
      ...state,
      receivablesTableData: { ...action.data },
    }
  }
  if (action.type === actionTypes.UNPAIDINVOICESDATAFETCHED) {
    if (!action.data) {
      return state
    }
    return {
      ...state,
      unpaidInvoices: { ...action.data },
    }
  }
  if (action.type === actionTypes.PAIDINVOICESDATAFETCHED) {
    if (!action.data) {
      return state
    }
    return {
      ...state,
      paidInvoices: { ...action.data },
    }
  }
  if (action.type === actionTypes.USERDATAFETCHED) {
    return {
      ...state,
      user: action.data,
    }
  }
  if (action.type === actionTypes.BUSINESSDATAFETCHED) {
    return {
      ...state,
      business: action.data,
    }
  }
  if (action.type === actionTypes.SETDEFAULTBUSINESSID) {
    return {
      ...state,
      defaultBusinessId: action.data,
    }
  }
  if (action.type === actionTypes.DASHBOARD_INFO_FETCHED) {
    return {
      ...state,
      dashboardInfo: action.data,
    }
  }
  if (action.type === actionTypes.SETLOADINGCASHFLOWDATA) {
    return {
      ...state,
      loadingCashflowData: action.data,
    }
  }
  if (action.type === actionTypes.SETLOADINGCASHFLOWCHARTDATA) {
    return {
      ...state,
      loadingCashflowChartData: action.data,
    }
  }
  if (action.type === actionTypes.SETLOADINGPAYABLESDATA) {
    return {
      ...state,
      loadingPayblesData: action.data,
    }
  }
  if (action.type === actionTypes.SETLOADINGPAYABLESCHARTDATA) {
    return {
      ...state,
      loadingPayblesChartData: action.data,
    }
  }
  if (action.type === actionTypes.SETLOADINGPAYABLESTABLEDATA) {
    return {
      ...state,
      loadingPayblesTableData: action.data,
    }
  }
  if (action.type === actionTypes.SETLOADINGUNPAIDBILLSDATA) {
    return {
      ...state,
      loadingUnpaidBillsData: action.data,
    }
  }
  if (action.type === actionTypes.SETLOADINGPAIDBILLSDATA) {
    return {
      ...state,
      loadingPaidBillsData: action.data,
    }
  }
  if (action.type === actionTypes.SETLOADINGRECEIVABLESDATA) {
    return {
      ...state,
      loadingReceivablesData: action.data,
    }
  }
  if (action.type === actionTypes.SETLOADINGUNPAIDINVOICESDATA) {
    return {
      ...state,
      loadingUnpaidInvoicesData: action.data,
    }
  }
  if (action.type === actionTypes.SETLOADINGPAIDINVOICESDATA) {
    return {
      ...state,
      loadingPaidInvoicesData: action.data,
    }
  }
  if (action.type === actionTypes.SETLOADINGRECEIVABLESCHARTDATA) {
    return {
      ...state,
      loadingReceivablesChartData: action.data,
    }
  }
  if (action.type === actionTypes.SETLOADINGRECEIVABLESTABLEDATA) {
    return {
      ...state,
      loadingReceivablesTableData: action.data,
    }
  }
  if (action.type === actionTypes.SETLOADINGCASHFLOWTABLEDATA) {
    return {
      ...state,
      loadingCashflowTableData: action.data,
    }
  }

  if (action.type === actionTypes.SUMMARYCASHFLOWDATA) {
    return {
      ...state,
      summaryCashflowData: action.data,
    }
  }
  if (action.type === actionTypes.SETPAYABLESSUMMARY) {
    return {
      ...state,
      payablesSummary: action.data,
    }
  }
  if (action.type === actionTypes.SETRECEIVABLESSUMMARY) {
    return {
      ...state,
      receivablesSummary: action.data,
    }
  }
  if (action.type === actionTypes.CODAT_INTEGRATED) {
    return {
      ...state,
      codatIntegrated: action.data,
    }
  }
  return state
}

export default reducer
